<template>
  <div class="box">
    <InfoHead />
    <div class="body">

      <template>
        <el-table :data="tableData" style="width: 100%;">
          <el-table-column prop="name" label="Bank Name :">
            <template slot-scope="scope">
              <el-input
                  :disabled="changecolor"
                  class="el-input elinput"
                  v-model="scope.row.name"
                  placeholder="Please fill"
                  type="text"
              />
            </template>
          </el-table-column>
        </el-table>
      </template>

      <template>
        <el-table :data="tableData1" style="width: 100%;">
          <el-table-column prop="name" label="ACCOUNT NUMBER :">
            <template slot-scope="scope">
              <el-input
                  :disabled="changecolor"
                  class="el-input elinput"
                  v-model="scope.row.name"
                  placeholder="Please fill"
                  type="text"
              />
            </template>
          </el-table-column>
        </el-table>
      </template>



    </div>
    <div class="foot">
      <div class="information-bottom" :class="{ 'changecolor': changecolor }" :disabled="submitButtonDisabled" @click="SubmitBankCard">Submit</div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import InfoHead from "../components/InfoHead.vue";

export default {
  name: "",
  components: {
    InfoHead
  },
  data() {
    return {
      //银行卡按钮禁用
      submitButtonDisabled: false,
      changecolor:false,
      options: [
        {
          value: "Bank of the Philippine Islands",
          label: "Bank of the Philippine Islands"
        },
        {
          value: "Union Bank of the Philippines",
          label: "Union Bank of the Philippines"
        },
        {
          value: "CIMB Bank",
          label: "CIMB Bank"
        },
        {
          value: "Gcash",
          label: "Gcash"
        }
      ],
      value: "Bank of the Philippine Islands",

      updateInfo: true,
      cardId: null,
      submitbut: false,
      activeName: "0",
      tableData: [
        {
          date: "Bank Name :",
          name: ""
        }
      ],
      tableData1: [
        {
          date: "ACCOUNT NUMBER :",
          name: ""
        }
      ]
    };
  },
  mounted() {
    let token = sessionStorage.getItem("token");
    ////console.log(token)
    axios
      .get(`/userbank/userbank/selectBank?uid=${+token}`)
      .then(res => {
        //console.log(res)
        if (res.data.data.length != 0) {
          if (
            res.data.data[0].bankcard != "" &&
            res.data.data[0].bankname != ""
          ) {
            (this.tableData1[0].name = res.data.data[0].bankcard),
              (this.tableData[0].name = res.data.data[0].bankname);
            this.cardId = res.data.data[0].id;
            this.submitbut = true;
            this.changecolor=true
          }
        }
      })
      .catch(() => {});
  },
  methods: {
    //添加/修改银行卡
    SubmitBankCard() {
      // 检查按钮是否已被禁用
      if (this.submitButtonDisabled) {
        return; // 如果禁用，则直接返回，不执行后续操作
      }
      // 禁用按钮
      this.submitButtonDisabled = true;

      // 设置10秒后重新启用按钮
      setTimeout(() => {
        this.submitButtonDisabled = false;
      }, 10000); // 10000毫秒 = 10秒
      if (this.submitbut) {
        this.$message({
          type: "error",
          message: "Please contact the customer to make modifications"
        });
        this.$router.go(-1);
      } else {
      let token = sessionStorage.getItem("token");

      // 检查表单信息是否完整
      if (this.tableData[0].name === "" || this.tableData1[0].name === "") {
        this.$message.error("Incomplete information");
        return;
      }

      axios
          .post("/userbank/userbank/saveBank", {
            bankname: this.tableData[0].name,
            bankcard: this.tableData1[0].name,
            uid: +token
          })
          .then(res => {
            if (res.data.data !== 0) {
              this.$message({
                type: "success",
                message: "UPDATE SUCCESS"
              });
              this.$router.push("/MyProfileviews");
            } else {
              this.$message({
                type: "error",
                message: "UPDATE error"
              });
            }
          })
          .catch(error => {
            // 处理错误
            this.$message.error("An error occurred: " + error.message);
          });
    }}
  }
};
</script>

<style scoped>
.box {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.el-dropdown {
  vertical-align: top;
}

.el-dropdown + .el-dropdown {
  margin-left: 15px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.body {
  margin-top: 80px;
  width: 100%;
}

.el-table__header-wrapper {
  display: none;
}

.cell {
  font-size: 13.5px;
}

.foot {
  margin-top: 40px;
  display: flex;
  justify-content: center;
}

.information-bottom {
  width: 80%;
  position: fixed;
  color: #fff;
  height: 55px;
  line-height: 55px;
  text-align: center;
  font-size: 25px;
  margin: 0 10% 0 10%;
  background-color: #a95159;
  cursor: pointer;
}
.changecolor{
    background-color: #C0C4CC;
}
.elinput ::placeholder{
  color: #000;

}
</style>
